<span class="box-icon">
  <img [src]="src" />
</span>
